// ---------------------------------------------------------------------------
// Taxonomy label humanizer for the Access Legitimacy grid (design v6 §3.3).
//
// Taxonomy values are stored and keyed lowercase and must NEVER be mutated;
// this pure function transforms them to Title Case at render across grid cells,
// filter options, and the drawer (PRD story 5). It Title-cases each
// whitespace-AND-hyphen separated segment, preserving the separators — so
// `non-human identity` → `Non-Human Identity` (the pinned rule for hyphenated
// labels, design Open Question 4). Idempotent on already-humanized input.
// ---------------------------------------------------------------------------

function capitalizeSegment(segment: string): string {
  if (segment.length === 0) return segment;
  return segment.charAt(0).toUpperCase() + segment.slice(1);
}

/**
 * Converts a lowercase taxonomy label to a Title Case display string.
 * Title-cases every space- and hyphen-delimited segment, keeping the original
 * separators intact (`internal human` → `Internal Human`; `non-human identity`
 * → `Non-Human Identity`). Empty string maps to empty string.
 */
export function humanizeLabel(label: string): string {
  return label
    .split(' ')
    .map((word) => word.split('-').map(capitalizeSegment).join('-'))
    .join(' ');
}
